<template>

  <div class="container">

    <BreadcrumSection :part1="$t('Organitzacions')"></BreadcrumSection>

    <h1>{{ $t("Organitzacions") }}</h1>

    <div v-if="totalElements === 0" class="alert alert-danger rounded-0" role="alert">
      {{ $t("No results") }}
    </div>
    <div v-else class="row">

      <div class="col-sm-12 col-md-8" >

        <div class="row">
          <div class="col-sm-12 col-md-8">
            <PaginationTable
                class="container"
                :show-pagination="true"
                v-model:current-page="currentPage"
                v-model:page-size="pageSize"
                :total="totalElements"
                :handle-current-change="handleCurrentChange">
            </PaginationTable>
          </div>

          <div class="col-sm-12 col-md-4">
            <div class="form-control-sm">
              <div class="d-flex align-items-center justify-content-end">
                <label class="form-check-label me-1" for="selectOrderBy">{{ $t("Ordenació") }}:</label>
                <select class="form-select form-select-sm select-auto-width" @change="handleOrderChange(selectedOrder)" v-model="selectedOrder" id="selectOrderBy">
                  <option value="organitzacio_sigles asc">{{$t('Sigles')}} asc.</option>
                  <option value="organitzacio_sigles desc">{{$t('Sigles')}} desc.</option>
                  <option value="organitzacio_nom_ca asc" selected>{{$t('Nom')}} asc.</option>
                  <option value="organitzacio_nom_ca desc">{{$t('Nom')}} desc.</option>
                </select>
              </div>
            </div>
          </div>

        </div>


        <ul class="list-group list-group-flush mt-1" >
          <li>
          <router-link-locale
              v-for="(organitzacio) in response.organitzacions"
              :key="organitzacio.id"
              :to="{name: 'organitzacio', params: {id: organitzacio.id, listPage: currentPage, listSort: selectedOrder}}"
              class="list-group-item list-group-item-action flex-column align-items-start p-2"
              tag="li"
          >

            <div class="mb-1">
              <span class="text-blue">{{ organitzacio[`organitzacio_nom_${locale}`] }}</span>
            </div>

            <div>
              <div class="text-secondary mb-1">
                <span>{{ organitzacio.organitzacio_sigles }}</span>
              </div>

              <div class="mb-1" >
                <span>{{ $t(organitzacio.subtipus) }}</span>
              </div>

            </div>
          </router-link-locale>
          </li>
        </ul>

        <PaginationTable
            class="container mt-3"
            :show-pagination="true"
            v-model:current-page="currentPage"
            v-model:page-size="pageSize"
            :total="totalElements"
            :handle-current-change="handleCurrentChange">
        </PaginationTable>

      </div>

      <div v-if="response.facetes" id="filtres" class="col-sm-12 col-md-4 mt-0">
        <FacetesFilter :data="response.facetes"  @apply-filter="handleApplyFilter" split-index="1" :marc="false"></FacetesFilter>
      </div>
    </div>

  </div>

</template>

<script>

import {computed, onMounted, ref} from "vue";
import RouterLinkLocale from "@/components/RouterLinkLocale.vue";
import PaginationTable from "@/components/PaginationTable.vue";
import store from "@/store";
import FacetesFilter from "@/components/FacetesFilter.vue";
import {useRoute, useRouter} from "vue-router";
import BreadcrumSection from "@/components/sections/BreadcrumbSection.vue";
import {
  createHandleApplyFilter,
  createHandleCurrentChange,
  createHandleOrderChange,
  getOrganitzacions
} from "@/composables/pageFunctions";
import {usePageWatcher, useQueryWatcher, useSortWatcher} from "@/composables/useWatchers";
import {useI18n} from "vue-i18n";
import {setMetadata} from "@/composables/metadataFunctions";


export default {
  name: "OrganitzacionsView",
  components: {BreadcrumSection, FacetesFilter, PaginationTable, RouterLinkLocale},

  setup() {
    const { locale } = useI18n();
    const response = ref([]);

    const query = ref("tipus:organitzacio")
    const initQuery = query.value
    const currentPage = ref(1);
    const totalElements = ref(1)
    const pageSize = computed(() => { return store.getters.pageSize})
    const selectedOrder = ref("organitzacio_nom_ca asc");

    const route = useRoute();
    const router = useRouter();
    const { t } = useI18n();

    onMounted(async () => {
      setMetadata(t('Organitzacions'))
      await store.dispatch('updateSearchSelected', "Organització");
      await store.dispatch('updateBackgroundImage', { view: route.name, url: require('@/assets/images/sections/banner-multicolor.webp') });
      currentPage.value = parseInt(route.params.page) || 1;
      const result = await getOrganitzacions(currentPage.value, store.getters.pageSize, query.value, route.params.sort, route.query)
      response.value = result
      totalElements.value = result.total
    });

    const handleCurrentChange = createHandleCurrentChange("organitzacions", router, route);
    const handleOrderChange = createHandleOrderChange("organitzacions", router, route, currentPage);

    usePageWatcher(getOrganitzacions, currentPage, response, totalElements, query, route, store);
    useSortWatcher(getOrganitzacions, currentPage, response, totalElements, query, route, store);
    useQueryWatcher(getOrganitzacions, currentPage, response, totalElements, query, route, store);

    const handleApplyFilter = async (newQuery) => {
      await createHandleApplyFilter({
        newQuery,
        callFunction:getOrganitzacions,
        currentPage,
        query,
        initQuery,
        response,
        totalElements,
        route,
        store
      });
    };


    return {
      response,
      query,
      locale,

      selectedOrder,
      currentPage,
      totalElements,
      pageSize,

      handleCurrentChange,
      handleApplyFilter,
      handleOrderChange
    }
  }
}

</script>

<style scoped>

</style>
